module.exports = __webpack_public_path__ + "static/chris-pearson-1f83092306155f85c6292c40413f99e0.png";